import React from 'react';

import WebcamView from '../../MediaDevices/WebcamView';
import DeviceSelector from '../../MediaDevices/DeviceSelector';
import AudioMeter from '../../Videoconference/Helpers/AudioMeter';
import { Range } from '../../Utilities/Range';
import { isFirefox, isChrome, isIOS } from 'react-device-detect';


export default class Audio extends React.Component {
    
    state = {
        show: false,
        audioinput: [],
        volume: window.sdk.videoconf().getGain().getVolume() >= 0 ? window.sdk.videoconf().getGain().getVolume() * 100 :  100 
    }

    audio = React.createRef();

    async loadDevices() {
        let { devices } = await window.sdk.videoconf().getDevices();

        this.setState({
            show: true,
            audioinput: devices['audioinput'],
            audiooutput: devices['audiooutput']
        });
    }

    async componentDidMount() {

        await this.loadDevices();

        window.sdk.event().on('audioOutputUpdated', (data) => {
            if(isChrome && !isIOS) {
                try {
                    this.audio.current.setSinkId(data.deviceId);
                }
                catch(err) {

                }
            }
        })

        window.sdk.event().on('deviceChange', () => {
            this.loadDevices(); 
        })

        while(!this.audio.current) {
            await window.sdk.sleep(300);
        }

        if(isChrome && !isIOS) {
            try {
                this.audio.current.setSinkId(window.sdk.videoconf().mediaDevices().getAudioOutputDeviceId());
            }
            catch(err) {
                
            }
        }
    }

    testAudio = () => {
        let audio = this.audio.current; // document.getElementById('audio-test');
        audio.currentTime = 0;
        if(!this.audioTestIsInPlay)
            audio.play();
        else
            audio.pause();
        this.audioTestIsInPlay = !this.audioTestIsInPlay
    }

    componentWillUnmount() {
        this.audio.current.pause();
        this.audioTestIsInPlay = false;        
    }

    volumeChange = (value) => {
        this.setState({ volume: value });
        window.sdk.videoconf().getGain().setVolume(value / 100);
    }

    volumeLower = () => {
        let volume = window.sdk.videoconf().getGain().getVolume();
        let value = Math.max(0, volume * 100 - 5);
        this.setState({ volume:value  });
        window.sdk.videoconf().getGain().setVolume(value / 100);
    }

    volumeLouder = () => {
        let volume = window.sdk.videoconf().getGain().getVolume();
        let value = Math.min(100, volume * 100 + 5);
        this.setState({ volume: value });
        window.sdk.videoconf().getGain().setVolume(value / 100);
    }

    render() {
        if (!this.state.show)
            return null;
        return (
            <div className="settings-audio">
                <h2 className='settings__subtitle'>Réglages audio</h2>

                <div className="test-device__row">
                    <div className="test-device__col">
                        <div className="settings__block">
                            <div className="device-selector-wrapper">
                                { ! isFirefox &&
                                    <DeviceSelector kind="audiooutput" disableButton={ true } label="Haut-parleurs" devices={this.state.audiooutput} />
                                }
                                <DeviceSelector kind="audioinput" label="Microphone" devices={this.state.audioinput} />
                            </div>
                        </div>
                    </div>
                    <div className="test-device__col">
                        <div className="device-selector-wrapper">
                            <div className="settings__block settings__block--audiooutput" onClick={this.testAudio}>
                                Tester les haut-parleurs <i className="icon-speaker-alt"></i>
                            </div>
                            <div className="settings__block settings__block--audiometer">
                                <label>Tester le microphone</label>
                                <AudioMeter className="settings__audiometer" meterId={ 'Main' } />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="settings-audio__volume">
                    <i className="icon-volume-down" onClick={this.volumeLower}></i>
                    <Range onChange={ this.volumeChange } initial={100} value={this.state.volume} />
                    <i className="icon-volume-up" onClick={this.volumeLouder}></i>
                </div>
                <audio ref={ this.audio } id="audio-test" src="/sound.mp3" />
            </div>
        );
    }
}
